import React, { useState } from 'react';
import {
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Paper,
    IconButton,
    Menu,
    MenuItem
} from '@mui/material';
import SortIcon from '../../../assets/images/Dashboard/chevron-down.svg';
import action from '../../../assets/images/Dashboard/action-img.svg';
import edit from '../../../assets/images/Dashboard/edit-img.svg';
import view from '../../../assets/images/Dashboard/view-img.svg';
import ascToDesc from '../../../assets/images/CustomerManagement/ascToDesc.svg';
import descToAsc from '../../../assets/images/CustomerManagement/descToAsc.svg';
import SbActionDropdownButton from '../../Buttons/SbActionDropdownButton';
import SbStatusDropdown from '../../Buttons/SbStatusDropdown';
import { SbAddBtn, SbFilterBtn } from '../../Buttons/Buttons';
import Select from 'react-select';
import calendar from '../../../assets/images/Dashboard/calendar-icon.svg';
import { Col, Dropdown, Form, Row } from 'react-bootstrap';
import DatePicker from 'react-datepicker';

import searchIcon from '../../../assets/images/Dashboard/search-icon.svg'

import columnFilter from '../../../assets/images/CustomerManagement/columnFilter.svg'
import valueFilter from '../../../assets/images/CustomerManagement/valueFilter.svg'
import SbDropdownButton from '../../Buttons/SbDropdownButton';
import AddMaterialMasterExtended from './AddMaterialMasterExtended';
import MaterialMasterExtendedBulkUploadModal from './MaterialMasterExtendedBulkUploadModal';

const data = [
    {
        materialNumber: 1001,
        trackedInSap: '--',
        isRepairable: '--',
        inspectionRequired: '--',
        requiresPreservation: '--',
        postToInspectionStock: '--',
        dualUom: '--',
        dualQuantity: '--',
        serialLevel: '--',
        batchSerialIndicator: '--',
        shelfLife: '--',
        storageConditions: '--',
        labelType: '--',
        piIndicatorForCC: '--',
        locatorControl: '--',
        bomControl: '--',
        availabilityToPromise: '--',
        alternateUom: '--',
        altConversion: '--',
        handlingUnitEnabled: '--',
        variantAllowed: '--',
        Status: 'Active',
    },
];

const columns = [
    { id: 'materialNumber', label: 'MATERIAL NUMBER', align: 'left', minWidth: '170px' },
    { id: 'trackedInSap', label: 'TRACKED IN SAP', align: 'left', minWidth: '160px' },
    { id: 'isRepairable', label: 'IS REPAIRABLE', align: 'left', minWidth: '150px' },
    { id: 'inspectionRequired', label: 'INSPECTION REQUIRED', align: 'left', minWidth: '200px' },
    { id: 'requiresPreservation', label: 'REQUIRES PRESERVATION', align: 'left', minWidth: '220px' },
    { id: 'postToInspectionStock', label: 'POST TO INSPECTION STOCK', align: 'left', minWidth: '230px' },
    { id: 'dualUom', label: 'DUAL UOM', align: 'left', minWidth: '120px' },
    { id: 'dualQuantity', label: 'DUAL QUANTITY', align: 'left', minWidth: '150px' },
    { id: 'serialLevel', label: 'SERIAL LEVEL', align: 'left', minWidth: '130px' },
    { id: 'batchSerialIndicator', label: 'BATCH SERIAL INDICATOR', align: 'left', minWidth: '220px' },
    { id: 'shelfLife', label: 'SHELF LIFE', align: 'left', minWidth: '120px' },
    { id: 'storageConditions', label: 'STORAGE CONDITIONS', align: 'left', minWidth: '200px' },
    { id: 'labelType', label: 'LABEL TYPE', align: 'left', minWidth: '120px' },
    { id: 'piIndicatorForCC', label: 'PI INDICATOR FOR CC', align: 'left', minWidth: '200px' },
    { id: 'locatorControl', label: 'LOCATOR CONTROL', align: 'left', minWidth: '180px' },
    { id: 'bomControl', label: 'BOM CONTROL', align: 'left', minWidth: '150px' },
    { id: 'availabilityToPromise', label: 'AVAILABILITY TO PROMISE (ATP)', align: 'left', minWidth: '260px' },
    { id: 'alternateUom', label: 'ALTERNATE UOM', align: 'left', minWidth: '160px' },
    { id: 'altConversion', label: 'ALT CONVERSION', align: 'left', minWidth: '160px' },
    { id: 'handlingUnitEnabled', label: 'HANDLING UNIT ENABLED', align: 'left', minWidth: '220px' },
    { id: 'variantAllowed', label: 'VARIANT ALLOWED (Y/N)', align: 'left', minWidth: '220px' },
    { id: 'Status', label: 'STATUS', align: 'left', minWidth: '150px' },
    { id: 'action', label: 'ACTION', align: 'left', minWidth: '80px', sortable: false },
];

const SpecialFeaturesTable = (props) => {
    const [order, setOrder] = useState('asc');
    const [orderBy, setOrderBy] = useState('id');
    const [anchorEl, setAnchorEl] = useState(null);
    const [currentSortColumn, setCurrentSortColumn] = useState(null);
    const [actionAnchorEl, setActionAnchorEl] = useState(false);
    const [selectedCustomer, setSelectedCustomer] = useState(null);

    const handleRequestSort = (event, property) => {
        setCurrentSortColumn(property);
        setAnchorEl(event.currentTarget);
    };

    const handleSortOrderChange = (order) => {
        setOrder(order);
        setOrderBy(currentSortColumn);
        setAnchorEl(null);
    };

    const handleActionClick = (event, customer) => {
        setSelectedCustomer(customer);
        setActionAnchorEl(event.currentTarget);
    };

    const handleActionClose = () => {
        setActionAnchorEl(false);
    };

    const handleMenuItemClick = (action) => {
        if (action === 'edit') {
            console.log('Edit Details for:', selectedCustomer);
            // Implement edit functionality here
        } else if (action === 'view') {
            console.log('View Details for:', selectedCustomer);
            // Implement view functionality here
        }
        handleActionClose();
    };

    const sortedData = React.useMemo(() => {
        const stabilizedData = data.map((el, index) => [el, index]);
        stabilizedData.sort((a, b) => {
            const orderModifier = order === 'asc' ? 1 : -1;
            if (a[0][orderBy] < b[0][orderBy]) {
                return -1 * orderModifier;
            }
            if (a[0][orderBy] > b[0][orderBy]) {
                return 1 * orderModifier;
            }
            return a[1] - b[1];
        });
        return stabilizedData.map((el) => el[0]);
    }, [data, order, orderBy]);

    const [fromDate, setFromDate] = useState(null);
    const [toDate, setToDate] = useState(null);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [showFilterMenu, setShowFilterMenu] = useState(false);
    const [showColumnFilterModal, setShowColumnFilterModal] = useState(false);
    const [showValueFilterModal, setShowValueFilterModal] = useState(false);
    const [showBulkUploadModal, setShowBulkUploadModal] = useState(false);

    const toggleFilterMenu = () => {
        setShowFilterMenu(!showFilterMenu);
    };

    const handleFromDateChange = (date) => {
        setFromDate(date);
    };

    const handleToDateChange = (date) => {
        setToDate(date);
    };
    const handleOpenModal = () => {
        setIsModalOpen(true);
    };

    const handleCloseModal = () => {
        setIsModalOpen(false);
    };
    const handleOpenColumnFilterModal = () => {
        setShowFilterMenu(false);
        setShowColumnFilterModal(true);
    };

    const handleCloseColumnFilterModal = () => {
        setShowColumnFilterModal(false);
    };
    const handleOpenValueFilterModal = () => {
        setShowFilterMenu(false);
        setShowValueFilterModal(true);
    };

    const handleCloseValueFilterModal = () => {
        setShowValueFilterModal(false);
    };

    const handleOpenBulkUploadModal = () => {
        setShowBulkUploadModal(true);
    };
    const handleCloseBulkUploadModal = () => {
        setShowBulkUploadModal(false);
    };

    return (
        <>
            <Row className='customermanagement-btns-container'>
                <Col md={3} className='customermanagement-backbtn-div'>
                    <span>Material Master Extended</span>
                </Col>
                <Col md={9} className='customermanagement-search-filter'>
                    <div className='customermanagement-header-btns filter-btn'>
                        <SbFilterBtn btnName="Filters" onClickEffect={toggleFilterMenu} />
                        {showFilterMenu && (
                            <Dropdown.Menu show className='filter-dropdown-options'>
                                <Dropdown.Item onClick={handleOpenColumnFilterModal}>
                                    <img src={columnFilter} alt="Column Filter" />&nbsp;&nbsp;
                                    Column Filter
                                </Dropdown.Item>
                                <Dropdown.Item onClick={handleOpenValueFilterModal}>
                                    <img src={valueFilter} alt="Value Filter" />&nbsp;&nbsp;
                                    Value Filter
                                </Dropdown.Item>
                            </Dropdown.Menu>
                        )}
                    </div>
                    <Col md={5}>
                        <div className='customermanagement-search'>
                            <Form.Control type="search" placeholder='Search' />
                            <img src={searchIcon} alt="Search" />
                        </div>
                    </Col>
                    <SbDropdownButton
                        // pageName="Zone Master"
                        btnName="Add"
                        openAddModal={() => { handleOpenModal("") }}
                        addBulkModel={handleOpenBulkUploadModal}
                    />
                </Col>
            </Row>
            <div className='customermanagement-table-div'>
                <TableContainer component={Paper} sx={{ maxHeight: 440 }} className='table-container'>
                    <Table>
                        <TableHead>
                            <TableRow>
                                {columns.map((column) => (
                                    <TableCell key={column.id} align={column.align} style={{ minWidth: column.minWidth }}>
                                        <div style={{ display: 'flex', alignItems: 'center' }} className='table-header-div'>
                                            {column.label}
                                            {column.sortable !== false && (
                                                <IconButton
                                                    size="small"
                                                    onClick={(event) => handleRequestSort(event, column.id)}
                                                >
                                                    <img src={SortIcon} alt="Sort" />
                                                </IconButton>
                                            )}
                                        </div>
                                    </TableCell>
                                ))}
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {sortedData.map((customer) => (
                                <TableRow key={customer.id}>
                                    {columns.map((column) => (
                                        <TableCell key={column.id} align={column.align}>
                                            {column.id === 'action' ? (
                                                <SbActionDropdownButton openAddModal={handleOpenModal} />
                                            ) : column.id === 'Status' ? (
                                                <span
                                                    className={`status-badge ${customer.Status === 'Active' ? 'complete-status no-dropdown-badge' : 'cancel-status no-dropdown-badge'}`}
                                                >
                                                    {customer.Status}
                                                </span>
                                            ) : (
                                                customer[column.id]
                                            )}
                                        </TableCell>
                                    ))}
                                </TableRow>
                            ))}
                        </TableBody>
                    </Table>
                    <Menu
                        anchorEl={anchorEl}
                        open={Boolean(anchorEl)}
                        onClose={() => setAnchorEl(null)}
                    >
                        <MenuItem onClick={() => handleSortOrderChange('asc')}>
                            <img src={ascToDesc} alt="" />&nbsp;&nbsp;
                            Ascending to Descending
                        </MenuItem>
                        <MenuItem onClick={() => handleSortOrderChange('desc')}>
                            <img src={descToAsc} alt="" />&nbsp;&nbsp;
                            Descending to Ascending
                        </MenuItem>
                    </Menu>
                </TableContainer>
                {isModalOpen && <AddMaterialMasterExtended open={isModalOpen} handleClose={handleCloseModal} />}
                {
                    showBulkUploadModal && <MaterialMasterExtendedBulkUploadModal
                        showBulkUploadModal={showBulkUploadModal}
                        handleCloseBulkUploadModal={handleCloseBulkUploadModal}
                    // deptData={deptData}
                    />
                }
            </div>
        </>
    );
};

export default SpecialFeaturesTable;
